import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faExchangeAlt, faFileInvoice, faIdCard, faCheckDouble } from '@fortawesome/free-solid-svg-icons';

const Traslado = () => {
    const [cedula, setCedula] = useState('');
    const [ordenes, setOrdenes] = useState([]);
    const [loading, setLoading] = useState(false);

    const [showModal, setShowModal] = useState(false);
    const [profesionales, setProfesionales] = useState([]);
    const [profesionalesFiltrados, setProfesionalesFiltrados] = useState([]);
    const [busquedaProf, setBusquedaProf] = useState('');
    const [profesionalSeleccionado, setProfesionalSeleccionado] = useState(null);

    const [selectedOrdenes, setSelectedOrdenes] = useState([]);

    useEffect(() => {
        if (showModal && profesionales.length === 0) {
            fetchProfesionales();
        }
    }, [showModal]);

    const fetchProfesionales = async () => {
        try {
            const response = await authAxios.get("barraza/lista_usuarios");
            setProfesionales(response.data);
            setProfesionalesFiltrados(response.data);
        } catch (error) {
            console.error('Error fetching profesionales:', error);
            Swal.fire('Error', 'No se pudo cargar la lista de profesionales', 'error');
        }
    };

    const handleSearchProf = (e) => {
        const text = e.target.value;
        setBusquedaProf(text);
        if (text === '') {
            setProfesionalesFiltrados(profesionales);
        } else {
            const filtrados = profesionales.filter(prof => 
                prof.nombre.toLowerCase().includes(text.toLowerCase()) || 
                prof.apellido.toLowerCase().includes(text.toLowerCase()) ||
                prof.identificacion.includes(text) ||
                (prof.cargo && prof.cargo.toLowerCase().includes(text.toLowerCase()))
            );
            setProfesionalesFiltrados(filtrados);
        }
    };

    const seleccionarProfesional = (prof) => {
        setProfesionalSeleccionado(prof);
        setCedula(prof.identificacion);
        setShowModal(false);
        setSelectedOrdenes([]);
        handleSearch(null, prof.identificacion);
    };

    const handleSearch = async (e, cedulaOverride = null) => {
        if (e) e.preventDefault();
        const cedulaBusqueda = cedulaOverride || cedula;
        if (!cedulaBusqueda) {
            Swal.fire({
                title: 'Atención',
                text: 'Por favor ingrese una cédula para consultar',
                icon: 'warning',
                confirmButtonColor: '#3085d6',
            });
            return;
        }

        setLoading(true);
        setSelectedOrdenes([]);
        Swal.fire({
            title: 'Consultando...',
            text: 'Buscando órdenes activas',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        try {
            // Se usa la ruta relativa ya que authAxios tiene el baseURL configurado
            const response = await authAxios.post("barraza/mostrar_ordenes_activas", { cedula: cedulaBusqueda });
            setOrdenes(response.data);
            Swal.close();
            
            if (response.data.length === 0) {
                Swal.fire({
                    title: 'Sin resultados',
                    text: 'No se encontraron órdenes activas para la identificación proporcionada.',
                    icon: 'info',
                    confirmButtonColor: '#3085d6',
                });
            }
        } catch (error) {
            console.error('Error fetching orders:', error);
            Swal.fire({
                title: 'Error',
                text: 'Hubo un problema al conectar con el servidor. Por favor intente de nuevo.',
                icon: 'error',
                confirmButtonColor: '#d33',
            });
        } finally {
            setLoading(false);
        }
    };

    const handleTraslado = (orden) => {
        Swal.fire({
            title: '¿Confirmar Traslado?',
            html: `¿Está seguro de trasladar la orden <b>${orden.orden_servicio}</b>?<br><small class="text-muted">${orden.Subject}</small>`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#28a745',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, trasladar ahora',
            cancelButtonText: 'Cancelar',
            reverseButtons: true
        }).then((result) => {
            if (result.isConfirmed) {
                enviarTraslado(orden.orden_servicio);
            }
        });
    };

    const enviarTraslado = async (orden_servicio) => {
        Swal.fire({
            title: 'Procesando Traslado',
            text: 'Por favor espere un momento...',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        try {
            const response = await authAxios.post("barraza/trasladar_orden", { orden_servicio });
            
            if (response.data.status === 'success') {
                Swal.fire({
                    title: '¡Traslado Exitoso!',
                    text: response.data.message || 'La orden ha sido trasladada correctamente al nuevo sistema.',
                    icon: 'success',
                    confirmButtonColor: '#28a745',
                }).then((result) => {
                    if (result.isConfirmed || result.isDismissed) {
                        handleSearch();
                    }
                });
            } else {
                Swal.fire({
                    title: 'Atención',
                    text: response.data.message || 'La operación no se pudo completar. Intente de nuevo.',
                    icon: 'warning',
                    confirmButtonColor: '#3085d6',
                });
            }
        } catch (error) {
            console.error('Error in transfer:', error);
            Swal.fire({
                title: 'Error de Conexión',
                text: 'No se pudo completar el traslado. Asegúrese de que el endpoint del servidor esté activo.',
                icon: 'error',
                confirmButtonColor: '#d33',
            });
        }
    };

    const handleSelectAll = (e) => {
        if (e.target.checked) {
            setSelectedOrdenes(ordenes.map(o => o.orden_servicio));
        } else {
            setSelectedOrdenes([]);
        }
    };

    const handleSelectOrden = (orden_servicio) => {
        setSelectedOrdenes(prev => 
            prev.includes(orden_servicio) 
                ? prev.filter(id => id !== orden_servicio)
                : [...prev, orden_servicio]
        );
    };

    const handleTrasladoMasivo = () => {
        if (selectedOrdenes.length === 0) {
            Swal.fire('Atención', 'Seleccione al menos una orden para trasladar masivamente', 'warning');
            return;
        }

        Swal.fire({
            title: '¿Confirmar Traslado Masivo?',
            html: `¿Está seguro de trasladar <b>${selectedOrdenes.length}</b> órdenes seleccionadas?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#28a745',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, trasladar todas',
            cancelButtonText: 'Cancelar',
            reverseButtons: true
        }).then(async (result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Procesando Traslado Masivo',
                    html: 'Por favor espere un momento... <br><br> <span id="traslado-progress">0</span> / ' + selectedOrdenes.length,
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading();
                    }
                });

                let successCount = 0;
                let errorCount = 0;

                for (let i = 0; i < selectedOrdenes.length; i++) {
                    const orden_servicio = selectedOrdenes[i];
                    try {
                        const response = await authAxios.post("barraza/trasladar_orden", { orden_servicio });
                        if (response.data.status === 'success') {
                            successCount++;
                        } else {
                            errorCount++;
                        }
                    } catch (error) {
                        errorCount++;
                    }
                    const progressEl = document.getElementById('traslado-progress');
                    if(progressEl) progressEl.innerText = (i + 1).toString();
                }

                Swal.fire({
                    title: 'Resultado de Traslado Masivo',
                    html: `Órdenes trasladadas exitosamente: <b>${successCount}</b><br>Errores: <b>${errorCount}</b>`,
                    icon: successCount > 0 ? 'success' : 'warning',
                    confirmButtonColor: '#28a745',
                }).then(() => {
                    setSelectedOrdenes([]);
                    handleSearch();
                });
            }
        });
    };

    return (
        <div className="content-wrapper bg-light">
            <div className="content-header pt-4">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0 fw-bold text-dark">Módulo de Traslado</h1>
                        </div>
                    </div>
                </div>
            </div>

            <div className="content">
                <div className="container-fluid">
                    <div className="card shadow-sm border-0 mb-4" style={{ borderRadius: '15px' }}>
                        <div className="card-body p-4">
                            <form onSubmit={handleSearch}>
                                <div className="row align-items-end">
                                    <div className="col-md-5">
                                        <label className="form-label fw-bold small text-uppercase text-muted mb-2">
                                            Identificación del Profesional
                                        </label>
                                        <div className="input-group input-group-lg shadow-none">
                                            <span className="input-group-text bg-white border-end-0" style={{ borderRadius: '10px 0 0 10px' }}>
                                                <FontAwesomeIcon icon={faIdCard} className="text-primary" />
                                            </span>
                                            <input
                                                type="text"
                                                className="form-control border-start-0"
                                                placeholder="Seleccione profesional..."
                                                style={{ borderRadius: '0', fontSize: '1rem' }}
                                                value={cedula}
                                                onChange={(e) => setCedula(e.target.value)}
                                            />
                                            <button 
                                                type="button" 
                                                className="btn btn-outline-primary" 
                                                style={{ borderRadius: '0 10px 10px 0' }}
                                                onClick={() => setShowModal(true)}
                                            >
                                                Seleccionar
                                            </button>
                                        </div>
                                        {profesionalSeleccionado && (
                                            <div className="mt-2 text-primary fw-bold small">
                                                {profesionalSeleccionado.nombre} {profesionalSeleccionado.apellido} - {profesionalSeleccionado.cargo}
                                            </div>
                                        )}
                                    </div>
                                    <div className="col-md-3 mt-3 mt-md-0">
                                        <button 
                                            type="submit" 
                                            className="btn btn-primary btn-lg w-100 shadow-sm d-flex align-items-center justify-content-center"
                                            disabled={loading}
                                            style={{ borderRadius: '10px', transition: 'all 0.3s' }}
                                        >
                                            <FontAwesomeIcon icon={faSearch} className="me-2" />
                                            {loading ? 'Consultando...' : 'Buscar Órdenes'}
                                        </button>
                                    </div>
                                    {ordenes.length > 0 && selectedOrdenes.length > 0 && (
                                        <div className="col-md-4 mt-3 mt-md-0 text-end">
                                            <button 
                                                type="button" 
                                                className="btn btn-success btn-lg shadow-sm"
                                                onClick={handleTrasladoMasivo}
                                                style={{ borderRadius: '10px', transition: 'all 0.3s' }}
                                            >
                                                <FontAwesomeIcon icon={faCheckDouble} className="me-2" />
                                                Trasladar ({selectedOrdenes.length})
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </form>
                        </div>
                    </div>

                    {ordenes.length > 0 ? (
                        <div className="card shadow-sm border-0" style={{ borderRadius: '15px' }}>
                            <div className="card-header bg-white border-bottom p-3">
                                <h5 className="card-title mb-0 fw-bold">Órdenes Encontradas ({ordenes.length})</h5>
                            </div>
                            <div className="card-body p-0">
                                <div className="table-responsive">
                                    <table className="table table-hover mb-0 align-middle">
                                        <thead className="bg-light">
                                            <tr className="text-muted small text-uppercase fw-bold">
                                                <th className="px-4 py-3 border-0 text-center" style={{ width: '50px' }}>
                                                    <input 
                                                        type="checkbox" 
                                                        className="form-check-input" 
                                                        checked={ordenes.length > 0 && selectedOrdenes.length === ordenes.length}
                                                        onChange={handleSelectAll}
                                                        style={{ cursor: 'pointer' }}
                                                    />
                                                </th>
                                                <th className="py-3 border-0">Orden</th>
                                                <th className="py-3 border-0">Externo</th>
                                                <th className="py-3 border-0 text-center">Cant</th>
                                                <th className="py-3 border-0 text-center">Avance</th>
                                                <th className="py-3 border-0">Paciente / Asunto</th>
                                                <th className="py-3 border-0">Vigencia</th>
                                                <th className="px-4 py-3 border-0 text-end">Acciones</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {ordenes.map((orden) => (
                                                <tr key={orden.Id} style={{ transition: 'background 0.2s', backgroundColor: selectedOrdenes.includes(orden.orden_servicio) ? 'rgba(40, 167, 69, 0.05)' : '' }}>
                                                    <td className="px-4 py-3 text-center">
                                                        <input 
                                                            type="checkbox" 
                                                            className="form-check-input" 
                                                            checked={selectedOrdenes.includes(orden.orden_servicio)}
                                                            onChange={() => handleSelectOrden(orden.orden_servicio)}
                                                            style={{ cursor: 'pointer' }}
                                                        />
                                                    </td>
                                                    <td className="py-3">
                                                        <span className="fw-bold text-primary">#{orden.orden_servicio}</span>
                                                    </td>
                                                    <td className="py-3 text-muted">{orden.orden_externa}</td>
                                                    <td className="py-3 text-center">
                                                        <span className="badge rounded-pill bg-info text-dark px-3 py-2">
                                                            {orden.cant}
                                                        </span>
                                                    </td>
                                                    <td className="py-3 text-center" style={{ width: '120px' }}>
                                                        <div className="progress" style={{ height: '20px', borderRadius: '10px' }}>
                                                            <div 
                                                                className={`progress-bar ${orden.id_contacto === 100 ? 'bg-success' : 'bg-primary'}`} 
                                                                role="progressbar" 
                                                                style={{ width: `${orden.id_contacto}%` }} 
                                                                aria-valuenow={orden.id_contacto} 
                                                                aria-valuemin="0" 
                                                                aria-valuemax="100"
                                                            >
                                                                {orden.id_contacto}%
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td className="py-3">
                                                        <div className="fw-bold">{orden.Subject}</div>
                                                        <div className="small text-muted text-truncate" style={{ maxWidth: '300px' }}>
                                                            {orden.Description}
                                                        </div>
                                                    </td>
                                                    <td className="py-3 small text-nowrap">
                                                        <div className="text-success fw-bold">{orden.StartTime}</div>
                                                        <div className="text-danger fw-bold">{orden.EndTime}</div>
                                                    </td>
                                                    <td className="px-4 py-3 text-end">
                                                        <button 
                                                            className="btn btn-success rounded-pill px-4 shadow-sm btn-sm fw-bold"
                                                            onClick={() => handleTraslado(orden)}
                                                            style={{ transition: 'transform 0.2s' }}
                                                            onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                                                            onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
                                                        >
                                                            <FontAwesomeIcon icon={faExchangeAlt} className="me-2" />
                                                            Trasladar
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    ) : !loading && (
                        <div className="text-center py-5">
                            <div className="mb-3">
                                <FontAwesomeIcon icon={faSearch} size="4x" className="text-light" />
                            </div>
                            <h4 className="text-muted">No hay datos para mostrar</h4>
                            <p className="text-muted small">Seleccione un profesional para buscar sus órdenes activas.</p>
                        </div>
                    )}
                </div>
            </div>

            {/* Modal de Profesionales */}
            {showModal && (
                <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1">
                    <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
                        <div className="modal-content" style={{ borderRadius: '15px' }}>
                            <div className="modal-header border-bottom-0">
                                <h5 className="modal-title fw-bold">Seleccionar Profesional</h5>
                                <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
                            </div>
                            <div className="modal-body">
                                <div className="mb-3">
                                    <div className="input-group">
                                        <span className="input-group-text bg-white">
                                            <FontAwesomeIcon icon={faSearch} className="text-muted" />
                                        </span>
                                        <input 
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Buscar por nombre, apellido, cédula o cargo..."
                                            value={busquedaProf}
                                            onChange={handleSearchProf}
                                        />
                                    </div>
                                </div>
                                
                                {profesionales.length === 0 ? (
                                    <div className="text-center py-4">
                                        <div className="spinner-border text-primary" role="status">
                                            <span className="visually-hidden">Cargando...</span>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="table-responsive">
                                        <table className="table table-hover align-middle">
                                            <thead className="table-light">
                                                <tr>
                                                    <th>Identificación</th>
                                                    <th>Nombres y Apellidos</th>
                                                    <th>Cargo</th>
                                                    <th className="text-end">Acción</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {profesionalesFiltrados.length > 0 ? (
                                                    profesionalesFiltrados.map(prof => (
                                                        <tr key={prof.identificacion}>
                                                            <td className="fw-bold">{prof.identificacion}</td>
                                                            <td>{prof.nombre} {prof.apellido}</td>
                                                            <td><span className="badge bg-secondary">{prof.cargo || 'N/A'}</span></td>
                                                            <td className="text-end">
                                                                <button 
                                                                    className="btn btn-sm btn-primary rounded-pill px-3"
                                                                    onClick={() => seleccionarProfesional(prof)}
                                                                >
                                                                    Seleccionar
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="4" className="text-center py-3 text-muted">
                                                            No se encontraron resultados para "{busquedaProf}"
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <style>{`
                .content-wrapper { min-height: calc(100vh - 100px); }
                .table thead th { font-weight: 600; letter-spacing: 0.05em; }
                .btn-primary { background-color: #0d6efd; border-color: #0d6efd; }
                .btn-primary:hover { background-color: #0b5ed7; border-color: #0a58ca; }
                .input-group:focus-within { box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.15) !important; border-radius: 10px; }
                .badge { font-weight: 600; }
                .table tbody tr:hover { background-color: rgba(13, 110, 253, 0.02); }
                .form-check-input:checked { background-color: #198754; border-color: #198754; }
            `}</style>
        </div>
    );
};

export default Traslado;